/* eslint-disable node/no-unsupported-features/node-builtins */
/* eslint-disable no-console */
import { updateLogs } from "../../state-management/slices/global/global.slice";
import { AppDispatch } from "../../state-management/store";
import MockLogs from "../../api/mock/data/logs";
import { ELogTypes } from "../enums/logging.enums";

export interface ILogMessage {
  type: ELogTypes;
  message: string;
  timestamp?: string;
  data?: any;
}

export class LoggingService {
  private logs: Array<ILogMessage>;
  private dispatch: AppDispatch;
  private static instance: LoggingService;

  private constructor(dispatch: AppDispatch) {
    this.dispatch = dispatch;
    this.logs = [];
    MockLogs.createLog();
  }

  public static getInstance(dispatch: AppDispatch): LoggingService {
    if (!LoggingService.instance) {
      LoggingService.instance = new LoggingService(dispatch);
    }

    return LoggingService.instance;
  }

  getLogs(): Array<ILogMessage> {
    return this.logs;
  }

  logMessage(log: ILogMessage): void {
    const newLog = {
      timestamp: new Date().toISOString(),
      ...log,
    };

    this.logs.push(newLog);

    if (process.env.REACT_APP_ENABLE_LOGGING === "true") {
      this.dispatch(updateLogs(newLog));
      console.info(`[${log.type}]:`, log);
    }
  }
}
